import React, { useRef, useCallback } from 'react'
import { IconButton, Typography } from '@mui/material'
import { Box, Paper } from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import RemoveIcon from '@mui/icons-material/Remove'
import { Colors } from '../../../styles/theme'

export default function IncDec({ qty, onIncrItemQty, onDecrItemQty }) {
    const intervalRef = useRef(null)
    const timeoutRef = useRef(null)

    // Press and hold for increment
    const handleIncrementMouseDown = useCallback(() => {
        onIncrItemQty() // Immediate increment on press

        // Start incrementing after 400ms delay (conventional timing)
        timeoutRef.current = setTimeout(() => {
            intervalRef.current = setInterval(() => {
                onIncrItemQty()
            }, 100) // Increment every 100ms while held (conventional timing)
        }, 400)
    }, [onIncrItemQty])

    // Press and hold for decrement
    const handleDecrementMouseDown = useCallback(() => {
        onDecrItemQty() // Immediate decrement on press

        // Start decrementing after 400ms delay
        timeoutRef.current = setTimeout(() => {
            intervalRef.current = setInterval(() => {
                onDecrItemQty()
            }, 100) // Decrement every 100ms while held
        }, 400)
    }, [onDecrItemQty])

    // Clear intervals when button is released
    const handleMouseUp = useCallback(() => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current)
            timeoutRef.current = null
        }
        if (intervalRef.current) {
            clearInterval(intervalRef.current)
            intervalRef.current = null
        }
    }, [])

    // Also clear on mouse leave (in case user drags off button)
    const handleMouseLeave = useCallback(() => {
        handleMouseUp()
    }, [handleMouseUp])

    return (
        <Paper
            elevation={18}
            sx={{
                width: 'fit-content', // ADDED: Only as wide as content
                display: 'inline-flex', // ADDED: Inline to prevent stretching
            }}
        >
            <Box display="flex" sx={{ mt: 0 }}>
                <IconButton
                    sx={{
                        borderRadius: 1.0,
                        border: `2px solid ${Colors.companyColors.eb_bolt}`,
                        color: Colors.white,
                        background: `${Colors.secondary}`,
                        minWidth: '44px',
                        minHeight: '44px',
                        mr: '-1.8px',
                        px: 0.8,
                        py: 0.4,
                        '&:hover': {
                            backgroundColor: `${Colors.companyColors.greenLight}`,
                        },
                    }}
                    onMouseDown={handleDecrementMouseDown}
                    onMouseUp={handleMouseUp}
                    onMouseLeave={handleMouseLeave}
                    onTouchStart={handleDecrementMouseDown}
                    onTouchEnd={handleMouseUp}
                >
                    <RemoveIcon />
                </IconButton>

                <Box
                    sx={{
                        border: `2px solid ${Colors.companyColors.eb_bolt}`,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        minWidth: '40px',
                        minHeight: '36px',
                        px: 1,
                    }}
                >
                    <Typography
                        variant="h6"
                        sx={{
                            lineHeight: 1,
                            margin: 0,
                            padding: 0,
                        }}
                    >
                        {qty}
                    </Typography>
                </Box>

                <IconButton
                    sx={{
                        borderRadius: 1.0,
                        border: `2px solid ${Colors.companyColors.eb_bolt}`,
                        color: Colors.white,
                        background: `${Colors.secondary}`,
                        ml: '-1.8px',
                        py: 0.4,
                        '&:hover': {
                            backgroundColor: `${Colors.companyColors.greenLight}`,
                        },
                    }}
                    onMouseDown={handleIncrementMouseDown}
                    onMouseUp={handleMouseUp}
                    onMouseLeave={handleMouseLeave}
                    onTouchStart={handleIncrementMouseDown}
                    onTouchEnd={handleMouseUp}
                >
                    <AddIcon />
                </IconButton>
            </Box>
        </Paper>
    )
}
